const SUNNY = {
  icon: "//skeletonoptics.com/cdn/shop/t/58/assets/sunny.png?v=141121576175985529591786527838",
  text: "Sunny",
};

const SALTWATER = {
  icon: "//skeletonoptics.com/cdn/shop/t/58/assets/saltwater-fishing.png?v=141473198037647031861786527838",
  text: "Saltwater Fishing",
};

const CLOUDY = {
  icon: "//skeletonoptics.com/cdn/shop/t/58/assets/cloudy.png?v=129809059595094596891786527838",
  text: "Cloudy",
};

const FRESHWATER = {
  icon: "//skeletonoptics.com/cdn/shop/t/58/assets/freshwater-fishing.png?v=135832167876862019171786527838",
  text: "Freshwater Fishing",
};

const OFFSHORE_FISHING = {
  icon: "//skeletonoptics.com/cdn/shop/t/58/assets/offshore-fishing.png?v=6323297554789641131786527838",
  text: "Offshore Fishing",
};

const FLY_FISHING = {
  icon: "//skeletonoptics.com/cdn/shop/t/58/assets/fly-fishing.png?v=5300135927496221871786527838",
  text: "Fly Fishing",
};

const SIGHT_FISHING = {
  icon: "//skeletonoptics.com/cdn/shop/t/58/assets/sight-fishing.png?v=136907486951483528531786527838",
  text: "Sight Fishing",
};

const COMFORT = {
  icon: "//skeletonoptics.com/cdn/shop/t/58/assets/comfort.png?v=28884515404922929131786527838",
  text: "Comfort",
};

const HUNTING = {
  icon: "//skeletonoptics.com/cdn/shop/t/58/assets/hunting.png?v=97435201173816724171786527838",
  text: "Hunting",
};

const LENS_COLOR_CONTENT = {
  "Blue Gun": [SUNNY, SALTWATER],
  "True Amber": [CLOUDY, HUNTING, FRESHWATER],
  "Gray": [SUNNY, COMFORT, OFFSHORE_FISHING],
  "Rustic Bronze": [SUNNY, FLY_FISHING, SIGHT_FISHING],
  "True Copper": [SUNNY, FLY_FISHING, SIGHT_FISHING],
  "Bronze Titanic": [SUNNY, FLY_FISHING, SIGHT_FISHING],
};

function updateFrameBoxContent(swatchValue) {
  const items = LENS_COLOR_CONTENT[swatchValue];
  if (!items) return;

  const frameBox = document.querySelector(".best-for-icons-frame-box");
  if (!frameBox) return;

  const iconsHTML = items
    .map(
      (item) => `
    <div class="frame-col">
      <img 
        src="${item.icon}" 
        srcset="${item.icon} 1x, ${item.icon.replace(".png", "@2x.png")} 2x"
        alt="${item.text} icon"
        class="icon"
        loading="lazy"
        style="width: 50px; height: auto;"
        height="auto"
      />
    </div>
  `
    )
    .join("");

  const labelsHTML = items
    .map(
      (item) => `
    <div class="frame-col">
      <p style="width: 50px;">${item.text}</p>
    </div>
  `
    )
    .join("");

  frameBox.innerHTML = `
    <div class="flex-col">
      <div class="frame-row frame-icons">${iconsHTML}</div>
      <div class="frame-row frame-labels">${labelsHTML}</div>
    </div>
  `;
}

document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (e) => {
    getSelectedSwatchValue(e.target);
  });

  initializeSelectedSwatch();
});

function initializeSelectedSwatch() {
  const initiallySelectedSwatchValue = document.querySelector(
    ".swatch-items-wrapper.lens-color"
  )?.firstElementChild?.dataset?.value;

  if (!initiallySelectedSwatchValue) return;

  updateFrameBoxContent(initiallySelectedSwatchValue);
}

function getSelectedSwatchValue(eventTarget) {
  const swatch = eventTarget.closest(".swatch-element");
  if (!swatch) return;

  const radio = swatch.querySelector("input[type='radio']");
  if (!radio || !radio.checked) return;

  const swatchValue = swatch.dataset.value;
  updateFrameBoxContent(swatchValue);
}
